import DBR from "dynamsoft-javascript-barcode";
DBR.BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@8.0.0/dist/";
// Please visit https://www.dynamsoft.com/customer/license/trialLicense to get a trial license
DBR.BarcodeReader.productKeys = "t0068NQAAAEc8pX1DRxxugaaA4RR1J2skUEZOwnfmXjR+z7Uphl7JuiFAroygLdHVuWoaM/MLokyYGN6IJ0A/wwDACjxNmZQ=";

// DBR.BarcodeReader.productKeys = "bd19951c";
// DBR.BarcodeReader._bUseFullFeature = true; // Control of loading min wasm or full wasm.
export default DBR;
